function getStyleProp(stylesKey, styles = {}, theme) {
  const styleProp = styles[stylesKey] || {};
  if (typeof styleProp === 'function') {
    return styleProp(theme);
  }
  return styleProp;
}

export { getStyleProp };
